import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type AffectBlockedPlaceToEnrollmentInput = {
  centerId: number
  enrollmentId: number
  blockedPlaceId: number
}

export const affectBlockedPlace = async (data: AffectBlockedPlaceToEnrollmentInput) => {
  const { centerId, blockedPlaceId, enrollmentId } = data
  return restApiClient
    .url(constructApiUrl(API.blockedPlaces.affect.url, { centerId, id: blockedPlaceId }))
    .post({ enrollmentId })
}
